

export interface BaseField {
  name: string;
  label: string;
  placeholder?: string;
  value: any;
  column: string;
  required: boolean;
}
export interface TextField extends BaseField {
  type: FieldTypeEnum.Text;
maxLength:number
}
export interface DropdownField extends BaseField {
  type: FieldTypeEnum.Dropdown;
  options: DropdownOption[];
}
export interface CalendarField extends BaseField {
  type: FieldTypeEnum.Calendar;
  minDate?: Date | null;
  maxDate?: Date | null;
}
export interface MultiSelectField extends BaseField{
  type:FieldTypeEnum.MultiSelect;
  count:Number;
  options: DropdownOption[];
  maxLength:Number
}
export interface RangeSliderField extends BaseField {
  type: FieldTypeEnum.RangeSlider;

}

export interface PasswordField extends BaseField {
  type: FieldTypeEnum.Password;
maxLength:number
}
export interface SearchFilterField extends BaseField {
  type: FieldTypeEnum.searchFilter;
maxLength:number
  options: DropdownOption[];
}
export interface DropdownOption {
  id: string;
  name: string;
}
export enum FieldTypeEnum {
  Text = 'text',
  Calendar = 'calendar',
  Dropdown = 'dropdown',
  RangeSlider='rangeSlider',
  MultiSelect='multiSelect',
  Password='password',
  searchFilter='searchFilter'
}


export type FromFieldType = TextField | CalendarField | DropdownField |RangeSliderField |MultiSelectField |PasswordField |SearchFilterField;

